import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material'
import { Control, Controller } from 'react-hook-form'
import react from 'react'

type ControlledTextFieldProps = {
  name: string;
  control: Control<any>;
  label: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  size?: 'small' | 'medium';
} & Omit<CheckboxProps, 'error'>

const ControlledCheckbox: react.FC<ControlledTextFieldProps> = ({
  name,
  control,
  label,
  labelPlacement,
  size
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { value, onChange, ref } }) => (
      <FormControlLabel
        value="end"
        control={<Checkbox
          size={size}
          checked={value}
          inputRef={ref}
          onChange={onChange}/>}
        label={label}
        labelPlacement={labelPlacement}/>)}/>
)

export default ControlledCheckbox
